import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  initialLoading: true,
  loading: false,
  weatherData: {},
  error: false,
};

const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {
    resetWeather: () => initialState,

    initWeatherRequest: state => {
      state.loading = true;
      state.error = false;
    },

    getWeatherSuccess: (state, action) => {
      state.initialLoading = false;
      state.loading = false;
      state.weatherData = action.payload;
    },

    getWeatherFailure: state => {
      state.initialLoading = false;
      state.loading = false;
      state.error = true;
    },
  },
});

export const {
  resetWeather,
  initWeatherRequest,
  getWeatherSuccess,
  getWeatherFailure,
} = weatherSlice.actions;

export default weatherSlice.reducer;